export default __webpack_public_path__ + "static/media/GiraffePage1.9cd7f040.txt";